export default (state = [], action) => {
    switch (action.type) {
        case 'FETCH_PERIODS':
            return action.payload;
        default:
            return state;
    }
};
